'use strict'

/** @import ../../common/types.js */

import * as React from 'react'
import Drawer from '@mui/material/Drawer'

import '../../common/types'

import { useGetDrawerBounds } from './FilterComponentHooks'
import { FilterGroup } from './FilterComponentExtra'

import CloseIcon from '@mui/icons-material/Close'
import { filterParameter } from './FilterConfig'
import { toQuicksightParameters } from './quicksightParameters'
import { produce } from 'immer'
import _set from 'lodash/set'
import { Provider, useDispatch, useSelector, useStore } from 'react-redux'
import { WindowScroller } from 'react-virtualized'
import { createStore } from 'redux'

export const filterStore = createStore(reducer)

function reducer(
  state = { load: false, controlState: new Map(), optionState: new Map(), controlHandlers: {} },
  action
) {
  return produce(state, (draft) => {
    switch (action.type) {
      default:
        break
      case 'SET_CONTROL': {
        draft.controlState = action.payload
        break
      }
      case 'SET_CONTROL_STATE': {
        const { id, path, value } = action.payload
        const control = draft.controlState.get(id)
        _set(control, path, value)
        break
      }

      case 'SET_OPTION': {
        draft.optionState = action.payload
        break
      }

      case 'SET_OPTION_VALUE': {
        const { id, value } = action.payload
        draft.optionState.get(id).state.value = value
        break
      }

      case 'SET_OPTION_STATE': {
        const { id, path, value } = action.payload
        const option = draft.optionState.get(id)
        _set(option, path, value)
        break
      }

      case 'SET_HANDLER': {
        draft.controlHandlers = action.payload
        break
      }

      case 'LOAD': {
        draft.load = true
        break
      }
    }
  })
}

/**
 * @function FilterView フィルターコンポーネント
 * @param {FilterViewProps} props
 */
const FilterComponent = (props) => {
  const {
    show = false,
    dashboardId = '',
    groups = [],
    controls = new Map(),
    options = new Map(),
    title = '表示対象設定',
    generateOutput,
    onValueChange,
    onClose,
    onReset,
    mode = ''
  } = props

  const { drawerRef, drawerWidth } = useGetDrawerBounds()

  const initialRef = React.useRef(produce({ controls, options }, () => {}))
  const _onReset = () => {
    const { controls, options } = initialRef.current
    filterStore.dispatch({ type: 'SET_CONTROL', payload: controls })
    filterStore.dispatch({ type: 'SET_OPTION', payload: options })

    onReset?.(controls)
  }

  /**
   *
   *
   * @param {Record<string, Control>} controlState
   * @returns
   */
  const createQuicksightParameters = (state) => toQuicksightParameters(state, filterParameter[dashboardId]?.({ mode }))

  const _onValueChange = (state) => {
    onValueChange?.(createQuicksightParameters(state))
  }

  const windowScroller = React.useRef(null)

  return (
    <Drawer
      ref={drawerRef}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          top: 'var(--header-height)',
          width: drawerWidth,
          boxSizing: 'border-box',
          maxHeight: 'calc(100dvh - var(--header-height))',
          zIndex: 10
        }
      }}
      variant="persistent"
      anchor="right"
      open={show}
      onClose={onClose}
    >
      <div className="filter-view  min-h-[400px] relative ">
        {
          <>
            <div className="flex justify-center px-4 py-3 sticky top-[0px] z-[3] bg-white border-b border-solid  gap-x-2 ">
              <p className="grow text-[20px] ">{title}</p>

              <button
                onClick={_onReset}
                className="px-3 py-1 rounded text-blue-500 min-w-[70px] focus:ring-4 focus:ring-blue-400/50  text-sm "
                data-testid="filterResetButton"
                id="filterResetButton"
              >
                リセット
              </button>
              <button type="" onClick={onClose} data-testid="filterCloseButton">
                <CloseIcon />
              </button>
            </div>

            <WindowScroller ref={windowScroller}>
              {() => (
                <>
                  <Provider store={filterStore}>
                    <Container
                      generateOutput={generateOutput}
                      controls={controls}
                      groups={groups}
                      options={options}
                      onValueChange={_onValueChange}
                    />
                  </Provider>
                </>
              )}
            </WindowScroller>
          </>
        }
      </div>
    </Drawer>
  )
}

const Container = (props) => {
  const { groups, controls, options, onValueChange, generateOutput } = props

  const dispatch = useDispatch()
  const store = useStore()
  const load = useSelector((s) => s.load)

  React.useEffect(() => {
    dispatch({ type: 'SET_CONTROL', payload: controls })
    dispatch({ type: 'SET_OPTION', payload: options })
    dispatch({ type: 'LOAD' })
  }, [controls, options])

  const noFilterText = '表示対象設定条件を取得中...'

  const debouncedGenerateOutput = React.useCallback(() => {
    return generateOutput(store.getState())
  }, [])

  React.useEffect(() => {
    const unsub = filterStore.subscribe(() => {
      onValueChange?.(debouncedGenerateOutput())
    })

    return () => unsub()
  }, [debouncedGenerateOutput])

  return (
    <>
      {load && (
        <div className="px-4" data-testid="filterContainer">
          {groups.length === 0 && <h2 className="text-lg mt-3 text-center">{noFilterText}</h2>}

          {groups.map((groupProps, index) => (
            <FilterGroup key={`group${index}`} {...groupProps} onValueChange={onValueChange} />
          ))}
        </div>
      )}
    </>
  )
}

export default FilterComponent
